export default {
      id: "geozones-visits-report-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/icons.svg#geozones-visits-report",
      toString: function () {
        return this.url;
      }
    }